/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ILoadingCriteria from './ILoadingCriteria';
import LoadingInfo from './LoadingInfo';

export default class AutoLoadingInfo extends LoadingInfo
{
    private _interval: number;
    private _amount: number;

    constructor(initial: number, criteria: ILoadingCriteria = null)
    {
        super(initial, criteria);

        if (criteria != null)
        {
            this.SetInterval(criteria.AutoInterval || 1000);
            this._amount = criteria.AutoAmount || 1;
        }
        else
        {
            this._amount = 1;
        }
    }

    public SetInterval(valueMs: number): this
    {
        if (valueMs == null || valueMs === 0) { return this; }

        if (this._interval != null) { clearInterval(this._interval); }
        this._interval = setInterval(() => this.Loaded(this._amount), valueMs);
        return this;
    }
}
